import { Injectable, NgZone } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { ROUTER_GO, ROUTER_GO_BACK } from '../action-types';
import { RouterGoAction, RouterGoBackAction } from './router-actions';
import { map, tap } from 'rxjs/operators';
import { UIRouter } from '@uirouter/core';
import { WindowRef } from '@vendor/window/window.component';
import { $log } from '@core/utils/logger';

@Injectable()
export class RouterEffects {

  constructor(private router: UIRouter,
              private ngZone: NgZone,
              private windowRef: WindowRef,
              private actions$: Actions) {
  }

  routerGo$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType<RouterGoAction>(ROUTER_GO),
        tap((action: RouterGoAction) => {

          const params: { [key: string]: string } = action.payload.params;
          const options: { [key: string]: string } = action.payload.options;
          const stateName: string = action.payload.name;

          this.ngZone.run(() => {
            this.router.stateService.go(
                stateName,
                params,
                options
            );
        });
        })
      );
  }, { dispatch: false });

  routerGoBack$ = createEffect(() => 
    this.actions$.pipe(
      ofType<RouterGoBackAction>(ROUTER_GO_BACK),
      map((action: RouterGoBackAction) => action),
      tap(() => this.windowRef.nativeWindow.history.back())
    )
  , { dispatch: false });

}
